import { Typography } from '@mui/material';
import HeaderWithActions from 'lib/designSystem/HeaderWithActions';
import EnhancedTable from 'lib/designSystem/Table';
import React from 'react';

import { DocumentApplied } from '../../../../types';

const headers: { key: string; label: string; type?: any }[] = [
  { key: 'folio', label: 'Folio' },
  { key: 'businessName', label: 'Cliente' },
  { key: 'stakeholderName', label: 'Deudor' },
  { key: 'issuedDate', label: 'Fecha de emisión', type: 'date' },
  { key: 'documentAmount', label: 'Monto total documento', type: 'money' },
  { key: 'appliedAmount', label: 'Monto aplicado', type: 'money' },
];

interface PayOutDetailAppliedDocumentsProps {
  documentsApplied: DocumentApplied[];
}

const PayOutDetailAppliedDocuments = (
  props: PayOutDetailAppliedDocumentsProps,
) => {
  const { documentsApplied } = props;

  return (
    <div>
      <HeaderWithActions
        title="Acá puedes ver los pagos realizados."
        variant="body1"
      />
      {documentsApplied.length === 0 ? (
        <Typography variant="body1">
          No hay documentos aplicados en este pago
        </Typography>
      ) : (
        <EnhancedTable
          dataHeaders={headers}
          data={documentsApplied}
          finalSumRow
        />
      )}
    </div>
  );
};

export default PayOutDetailAppliedDocuments;
